import { useGoogleMaps } from "@hooks/shared/useGoogleMaps";
import INewAddress from "@models/INewAddress";
import React from "react";

type Props = {
    address: INewAddress;
};

export const OwGoogleZoomedStaticMap = (props: Props) => {
    const googleMaps = useGoogleMaps({});

    const [zoomedMapSource, setZoomedMapSource] = React.useState<string | null>(null);

    const getZoomedMapSource = (): string | null => {
        // get modal size
        const elem = document.getElementById("mainReactModal");

        console.log("elem", elem);

        if (!elem) {
            return null;
        }

        const padding = 18;

        const width = elem.clientWidth - padding;
        const height = elem.clientHeight - padding;

        const encodedAddress = googleMaps.getEncodedAddress(props.address);
        const zoomLevel = googleMaps.getZoomLevel();
        const size = `${width}x${height}`;
        // const markerSize = this.getMarkerSize();
        const markerColor = googleMaps.getMarkerColor();
        const apiKey = googleMaps.getGoogleMapsAPIKey();

        const zoomedParameters = `center=${encodedAddress}&zoom=${zoomLevel}&size=${size}&markers=${markerColor}${encodedAddress}&maptype=roadmap&key=${apiKey}`;

        const zoomedGoogleMapsSource = `https://maps.googleapis.com/maps/api/staticmap?${zoomedParameters}`;

        return zoomedGoogleMapsSource;
    };

    React.useEffect(() => {
        setZoomedMapSource(getZoomedMapSource());
    }, []);

    if (!zoomedMapSource) {
        return null;
    }

    return <div className={"OwGoogleZoomedStaticMap d-flex justify-content-center align-items-center h-100"}>
        <img alt={"Zoomed Google Map"} src={zoomedMapSource} className={"border border-dark rounded"} />
    </div>;
};
